module.exports = "<p>\n  performance-product-statistics works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/performance/performance-product-statistics/performance-product-statistics.component.html
// module id = ./src/app/routes/performance/performance-product-statistics/performance-product-statistics.component.html
// module chunks = 9